import InputMask from 'inputmask'

export default {
  bind: function (el, binding) {
    InputMask(binding.value).mask(el)
  }
}
